import * as React from "react";

import { SimpleForm, useRefresh } from "react-admin";
import { useLogin, useNotify } from "react-admin";
import { Card, CardContent, Button, styled, Typography, Box } from "@mui/material";
import { settings } from "app";
import { tenantLoginConfig } from "utils/tenants";

const CustomLoginPage = props => {
  return <CustomLogin />;
};

export default CustomLoginPage;

const CustomLogin = props => {
  // const [username, setUserName] = useState("");
  // const [password, setPassword] = useState("");

  const tenant = settings.tenant;
  const config = tenantLoginConfig[tenant];

  const login = useLogin();
  const notify = useNotify();
  const refresh = useRefresh();

  // const { executeRecaptcha } = useGoogleReCaptcha();

  const handleFormSubmit = async (e, thirdParty) => {
    e.preventDefault();
    // const captchaToken = await executeRecaptcha("login_mu");

    // if (!captchaToken) {
    //   return;
    // }

    // if (!thirdParty && (!username || !password)) {
    //   notify("Невалидни имейл или парола", { type: "error" });
    //   return;
    // }

    // const loginData = { username, password, reCaptchaToken: captchaToken, thirdParty };
    const loginData = { thirdParty };

    login(loginData).catch(() => notify("Грешка при влизане в системата", { type: "error" }));
    refresh();
  };

  const StyledLoginPage = styled(Box)({
    // backgroundImage: config.backgroundImage
    //   ? ` url(${config.backgroundImage}), ${config.background}`
    //   : config.background,
    backgroundImage: `${config.background}`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  });

  const StyledLoginCard = styled(Card)({
    backgroundColor: "rgba(255, 255, 255)",
    width: "500px",
    maxHeight: "500px",
    borderRadius: "4px",
  });

  const StyledCardContent = styled(CardContent)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  });

  return (
    <StyledLoginPage {...props}>
      <StyledLoginCard>
        <StyledCardContent>
          <Box
            sx={{
              m: 2,
              height: "110px",
              scale: 0.9,
              background: `${config.logoBackground}`,
              padding: 1,
              borderRadius: "4px",
            }}
          >
            <img
              src={config.logo}
              alt="university-logo"
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
          <SimpleForm
            toolbar={false}
            onSubmit={handleFormSubmit}
          >
            {/* <TextInput
              source="Username"
              name="username"
              label="Потребител"
              value={username}
              onChange={e => setUserName(e.target.value)}
            />

            <TextInput
              source="Password"
              name="password"
              label="Парола*"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <Button
              mt={4}
              fullWidth
              color="error"
              variant="contained"
              onClick={handleFormSubmit}
            >
              Влез
            </Button> */}
            <Typography sx={{ textAlign: "center", fontWeight: "bold", color: `${config.titleColor}` }}>
              Добре дошли в административния панел на Университетска административна информационна система на{" "}
              {config.title}.
            </Typography>
            <Typography
              color={config.subTitleColor}
              sx={{ margin: "20px  auto 0" }}
            >
              Моля, впишете се със служебния си имейл.
            </Typography>
            <Button
              sx={{
                marginTop: 4,
                background: config.buttonColor,
                "&:hover": {
                  background: config.buttonHoverColor,
                },
              }}
              fullWidth
              variant="contained"
              onClick={e => handleFormSubmit(e, "google")}
            >
              Вход
            </Button>
          </SimpleForm>
        </StyledCardContent>
      </StyledLoginCard>
    </StyledLoginPage>
  );
};
